import React, { Component, createRef } from 'react'
import {
  Button,
  Grid,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Select,
  MenuItem,
} from '@material-ui/core'

import WeedMapMenuListContainer from './WeedMapMenuList/WeedMapMenuListContainer'
import WeedmapDiscontinueItemsModal from './WeedmapDiscontinueItemsModal'
import ModalDialog from '../common/ModalDialog'

class WeedMapMenuContainer extends Component {
  state = {
    mappingList: [],
  }

  discontinueWMItemsModal = createRef()

  componentDidMount() {
    this.setState({
      mappingList: this.props.categoryList,
    })
  }

  componentDidUpdate(nextProps) {
    if (nextProps.categoryLastModified != this.props.categoryLastModified) {
      // eslint-disable-line
      this.setState({
        mappingList: this.props.categoryList,
      })
    }
  }

  openMapCategoriesModal = () => {
    this.mapCategoriesModal.handleClickOpen()
  }

  openDiscontinueWMItemsModal = () => {
    this.discontinueWMItemsModal.current.handleClickOpen()
  }

  showError = (message) => {
    this.props.showError(message)
  }

  discontinueWMItems = (password) => {
    const data = { password }
    this.props.discontinueWeedmapsItems(data, () =>
      this.discontinueWMItemsModal.current.handleClose(),
    )
  }

  setWeedmapCategory = (index) => (event) => {
    const { mappingList = [] } = this.state
    const udpatedMappingList = [...mappingList].filter((cat) => cat.active)
    udpatedMappingList[index] = { ...udpatedMappingList[index], wmCategory: event.target.value }
    this.setState({
      mappingList: udpatedMappingList,
    })
  }

  mapCategories = () => {
    const { mappingList = [] } = this.state
    this.props.performCategoryMapping(
      mappingList
        .filter((category) => category.active && category.wmCategory)
        .map((category) => ({ categoryId: category.id, wmCategory: category.wmCategory })),
      () => this.mapCategoriesModal.handleClose(),
    )
  }

  render() {
    const { mappingList = [] } = this.state
    const {
      syncMenu,
      resetSync,
      lastModified,
      categoryMapping = [],
      categoryList = [],
      resetDelete,
      permitted = false,
      version = 1,
      defaultTagMapping = {},
      tagMapping = [],
      productsList = [],
      brandsList = [],
      weedmapTags = [],
      thirdPartyProducts = {},
      thirdPartyBrands = [],
      categoryLastModified,
    } = this.props

    const mainCategories =
      (defaultTagMapping['MAIN_CATEGORY'] && defaultTagMapping['MAIN_CATEGORY']['']) || []
    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <h1>Manage Menu</h1>
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={9} className="btns-mb">
                {permitted ? (
                  <div className="pull-right">
                    {version === 2 ? (
                      <Button
                        className="primary-button margin"
                        onClick={this.openMapCategoriesModal}
                      >
                        Map Categories
                      </Button>
                    ) : null}
                    <Button className="primary-button margin" onClick={syncMenu}>
                      Sync Menu
                    </Button>
                    <Button className="primary-button margin" onClick={resetSync}>
                      Reset Sync
                    </Button>
                    {version === 2 ? (
                      <Button
                        className="primary-button margin"
                        onClick={this.openDiscontinueWMItemsModal}
                      >
                        Discontinue WM Items
                      </Button>
                    ) : null}
                    <Button className="danger-button margin" onClick={resetDelete}>
                      {' '}
                      Reset & Delete{' '}
                    </Button>
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              {/* <Grid container>
                                <Grid item xs={12} sm={12} md={12} lg={12}> */}
              <WeedMapMenuListContainer
                lastModified={lastModified}
                categoryMapping={categoryMapping}
                categoryList={categoryList}
                onSave={this.props.onSave}
                onError={this.props.onError}
                permitted={permitted}
                version={version}
                tagMapping={tagMapping}
                productsList={productsList}
                brandsList={brandsList}
                weedmapTags={weedmapTags}
                getWeedmapProducts={this.props.getWeedmapProducts}
                thirdPartyProducts={thirdPartyProducts}
                getBLAZEProducts={this.props.getBLAZEProducts}
                showError={this.props.showError}
                getThirdPartyBrands={this.props.getThirdPartyBrands}
                thirdPartyBrands={thirdPartyBrands}
                performCategoryMapping={this.props.performCategoryMapping}
                enableWeedmapforProducts={this.props.enableWeedmapforProducts}
                disableWeedmapforProducts={this.props.disableWeedmapforProducts}
                onChangeSearchTerm={this.props.onChangeSearchTerm}
                onSearch={this.props.onSearch}
                updateCategory={this.props.updateCategory}
                getThirdPartyProducts={this.props.getThirdPartyProducts}
                updateWeedmapMapping={this.props.updateWeedmapMapping}
                categoryMappingList={mappingList}
                categoryLastModified={categoryLastModified}
              />
              {/* </Grid>
                            </Grid> */}
            </Paper>
            <ModalDialog
              title={'Map Categories'}
              ref={(c) => (this.mapCategoriesModal = c)}
              onConfirm={this.mapCategories}
              //onOpen={this.onOpen}
              confirmText={'Map Categories'}
              rootClass="modal-choose-pro"
            >
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>BLAZE Categories</TableCell>
                      <TableCell>WM Categories</TableCell>
                      {permitted ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {mappingList
                      .filter((cat) => cat.active)
                      .map((category, index) => {
                        return (
                          <TableRow key={category.id}>
                            <TableCell>{category.name}</TableCell>
                            <TableCell>
                              <Select
                                value={category.wmCategory}
                                //onChange={this.setWeedmapCategory}
                                MenuProps={{ className: 'no-backdrop-select' }}
                                style={{ minWidth: 200, marginLeft: 10 }}
                                onChange={this.setWeedmapCategory(index)}
                              >
                                {mainCategories.map((item, index) => {
                                  return (
                                    <MenuItem key={index} value={item.value}>
                                      {item.name}
                                    </MenuItem>
                                  )
                                })}
                              </Select>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            </ModalDialog>
            <WeedmapDiscontinueItemsModal
              ref={this.discontinueWMItemsModal}
              onConfirm={this.discontinueWMItems}
              showError={this.showError}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default WeedMapMenuContainer

WeedMapMenuContainer.defaultProps = {
  syncMenu: () => {},
  resetSync: () => {},
}



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuContainer.js